import { SignTitle, Warning } from '@/components'
import { useCheditor } from '@/utils'
import { useDebounceFn } from 'ahooks'
import { Button, Form, Input, message, Modal, Radio, Select } from 'antd'
import Scrollbars from 'react-custom-scrollbars'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useCloneHtml, useCreatePhishTemplate, useGetEducationTemplateList } from './utils'
import { Message } from '@/components/message'
import { t } from '@/i18n'
const { useForm } = Form
export const CreatePhishing = props => {
  const [createPhishTemplate] = useCreatePhishTemplate()
  const [templateList, getTemplateList] = useGetEducationTemplateList()

  let [content, setContent] = useState('')
  const [form] = useForm()
  const { isModalVisible, handleCancel } = props
  const [type, setType] = useState('0')
  const onFinish = (values: any) => {
    let { name, redirect, autocommit, security_id } = values
    let value = editor?.getData()
    // if (value?.indexOf('window.location.replace') > 0) {
    //   value = value.replaceAll('window.location.replace', 'let  ddd')
    //   editor?.setData(value)
    // }
    // if (value?.indexOf('window.location.href') > 0) {
    //   value = value.replaceAll('window.location.href', 'let  ddd')
    //   editor?.setData(value)
    // }
    // if (value?.indexOf('<script') > 0 && value?.indexOf('</script>') > 0) {
    //   let arr = value.split('<script')
    //   arr.map(() => {
    //     // value.substring(value.indexOf('<script>'), value.indexOf('</script>'))
    //     if (value.indexOf('<script') > 0 && value.indexOf('</script') > 0) {
    //       value = value.replaceAll(
    //         value.substring(value.indexOf('<script'), value.indexOf('</script>') + 9),
    //         '',
    //       )
    //     }
    //   })
    // }
    if (redirect) {
      if (security_id === '1') {
        security_id = redirect
        redirect = templateList?.items?.filter(e => redirect === e.id)?.[0]?.redirect
      }
      if (security_id === '0' && !(redirect.includes('http://') || redirect.includes('https://'))) {
        redirect = `https://${redirect}`
      }
    }
    createPhishTemplate({
      name,
      content: value,
      redirect: redirect,
      security_id: security_id,
      cover: '/static/default/phishPage.png',
      autocommit: autocommit?.length || 2,
    })
      .then(() => {
        handleCancel(true)
        form.resetFields()
      })
      .catch(() => {})
  }
  let [element, setElement] = useState<HTMLDivElement | null>(null)
  const { editor } = useCheditor({
    height: 270,
    initData: '',
    element,
    onKey: e => {
      run(e)
    },
    onBlur: e => {
      setContent((content = e))
    },
  })

  const { run } = useDebounceFn(
    value => {
      setContent(value)
    },
    {
      wait: 500,
    },
  )
  // 克隆
  const [cloneValue, setCloneValue] = useState('')
  const [cloneStatus, setCLoneStatus] = useState(false)
  const [cloneHtml, cloneHtmlLoading] = useCloneHtml()
  const cloneUrl = () => {
    if (cloneValue) {
      cloneHtml({ url: cloneValue }).catch(err => {
        if (err.code !== 500 && err.code !== 400) {
          Message.success('克隆成功')
          setCLoneStatus(false)
          setTimeout(() => {
            let value = err
            // if (value.indexOf('window.location.replace') > 0) {
            //   value = value.replaceAll('window.location.replace', 'let  ddd')
            // }
            // if (value.indexOf('window.location.href') > 0) {
            //   value = value.replaceAll('window.location.href', 'let  ddd')
            // }
            // if (value?.indexOf('<script') > 0 && value?.indexOf('</script>') > 0) {
            //   let arr = value.split('<script')
            //   arr.map(item => {
            //     if (value.indexOf('<script') > 0 && value.indexOf('</script') > 0) {
            //       value = value.replaceAll(
            //         value.substring(value.indexOf('<script'), value.indexOf('</script>') + 9),
            //         '',
            //       )
            //     }
            //   })
            // }
            // console.log(value)

            // value.replaceAll('</script>', '</span>')
            // console.log(value)
            editor.setData(value)
          }, 200)
          return
        }
        setCLoneStatus(true)
      })
    }
  }
  useEffect(() => {
    getTemplateList({ page: 1, limit: 9999, keyword: '' }).catch(_ => {})
  }, [])
  // useEffect(() => {
  //   let value = editor?.getData()
  //   if (value?.indexOf('<script>') > 0 && value?.indexOf('</>') > 0) {
  //     let arr = value.split('<script>')
  //     arr.map(() => {
  //       // value.substring(value.indexOf('<script>'), value.indexOf('</>'))
  //       // if (value.indexOf('<script') > 0 && value.indexOf('</script') > 0) {
  //       //   value = value.replaceAll(
  //       //     value.substring(value.indexOf('<script'), value.indexOf('</script>') + 9),
  //       //     '',
  //       //   )
  //       // }
  //     })
  //     editor?.setData(value)
  //   }
  //   // if (value?.indexOf('window.location.replace') > 0) {
  //   //   value = value.replaceAll('window.location.replace', 'let  ddd')
  //   //   editor?.setData(value)
  //   // }
  //   // if (value?.indexOf('window.location.href') > 0) {
  //   //   value = value.replaceAll('window.location.href', 'let  ddd')
  //   //   editor?.setData(value)
  //   // }
  // }, [editor?.getData()])
  return (
    <Create
      title={
        <>
          <SignTitle show>{t('添加自定义钓鱼页模板')}</SignTitle>
        </>
      }
      visible={isModalVisible}
      onOk={() => {
        form.submit()
        // setSubmit({ accomplish: true, timestamp: new Date().getTime() })
      }}
      onCancel={() => {
        form.resetFields()
        handleCancel(false)
      }}
      width={800}
      okText="保存"
      centered
    >
      <div style={{ width: '100%', height: '450px' }}>
        <Scrollbars>
          <FormType
            onFinish={onFinish}
            form={form}
            layout="vertical"
            initialValues={{ security_id: '0' }}
          >
            <Form.Item
              name="name"
              label="模板名称"
              rules={[
                { required: true, message: '请输入模板名称' },
                { max: 25, message: '模板名称最多25个字符' },
                {
                  pattern: /^(?=.*\S).+$/,
                  message: '模板名称不能全部为空格!',
                },
              ]}
            >
              <Input placeholder="请输入" />
            </Form.Item>
            <Form.Item
              name="redirect"
              label={
                <div style={{ fontWeight: 600 }}>
                  <span style={{ color: '#F53F3F', marginRight: 4 }}>*</span>
                  {t('钓鱼页')}
                </div>
              }
            >
              <Form.Item
                label="快速克隆"
                validateStatus={cloneStatus && 'error'}
                help={cloneStatus && '未找到目标页面'}
                name="url"
              >
                <Input
                  placeholder="https://example.com"
                  onChange={e => setCloneValue(e.target.value)}
                />

                <Button
                  type="primary"
                  style={{ marginLeft: 10 }}
                  onClick={() => cloneUrl()}
                  loading={cloneHtmlLoading}
                >
                  {t('克隆')}
                </Button>
              </Form.Item>
              <div ref={setElement} />
            </Form.Item>
            <Form.Item name="security_id" label="默认重定向页面">
              <Radio.Group
                onChange={e => {
                  setType(e.target.value)
                  form.setFieldValue('redirect', null)
                }}
              >
                <Radio value="0"> {t('输入自定义URL')} </Radio>
                <Radio value="1"> {t('选择安全教育模板')} </Radio>
              </Radio.Group>
            </Form.Item>
            {type === '0' && (
              <Form.Item
                name="redirect"
                // label="重定向页面"
                rules={[{ type: 'url', message: '请输入正确的重定向页面' }]}
              >
                <Input placeholder="https://example.com" />
              </Form.Item>
            )}
            {type === '1' && (
              <Form.Item
                name="redirect"
                // label="重定向页面"
                // rules={[{ type: 'url', message: '请输入正确的重定向页面' }]}
              >
                <Select
                  showSearch
                  optionFilterProp="label"
                  style={{ width: 420 }}
                  placeholder="请选择安全教育模板"
                  options={templateList?.items?.map(item => ({
                    label: `${item.name}(${item.redirect})`,
                    value: item.id,
                  }))}
                />
              </Form.Item>
            )}
            <Warning
              text={
                '可输入自定义URL或选择系统内置的安全教育模板作为重定向页面，并将钓鱼页面代码中的重定向页面URL改为{{.Url}}'
              }
              style={{ width: 700 }}
            />

            {/* <Form.Item name="autocommit">
              <Checkbox.Group>
              <Checkbox value={1} style={{ lineHeight: '32px' }}>
              自动提交捕获的数据
              </Checkbox>
              <Alert
              style={{ marginTop: '28px' }}
              message="请输入重定向页面URL后再选择是否自动提交捕获的数据，否则选择无效"
              type="warning"
              showIcon
              />
              </Checkbox.Group>
              </Form.Item> */}
          </FormType>
        </Scrollbars>
      </div>
    </Create>
  )
}

const FormType = styled(Form)`
  padding-right: 30px;
  .subject {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .ant-input {
    width: 420px;
  }
  .ant-row {
    display: block;
  }
`
const Create = styled(Modal)`
  .ant-modal-body {
    padding-top: 0;
    padding-bottom: 10px;
  }
  .header-table {
    width: 100%;
    display: flex;
    border-radius: 8px;
    margin-bottom: 18px;
    height: 32px;
    .tab-item {
      cursor: pointer;
      width: 100%;
      display: flex;
      justify-content: center;
      background-color: #efefef;
      align-items: center;
      margin-right: 4px;
      &:nth-child(1) {
        border-radius: 16px 0px 0px 16px;
      }
      &:nth-last-child(1) {
        border-radius: 0px 16px 16px 0px;
      }
    }
  }
`
